<template>
  <div class="connection">

    <div class="mode"><v-icon>{{icon}}</v-icon></div>
    <div v-bind:class="lineStyle"></div>
    <div class="direction">
      <div v-if="leg.line !== undefined">
        <span  class="line_description" :style="{color: line_color, backgroundColor: line_background_color, borderColor: border_color}">
        {{leg.line.publicCode}} 
        </span>
        <br>
        <span v-if="'destinationDisplay' in leg.serviceJourneyEstimatedCalls[0]">
          Richting {{leg.serviceJourneyEstimatedCalls[0].destinationDisplay.frontText}}
        </span>

        (<i>{{duration}} min</i>)
      </div>
      <div v-else>
        Loop {{duration}} minuten
      </div>
      <!-- Tram 5 Richting
      <br>
      test -->
    </div>

    
    
  </div>
  

</template>

<script>
import Vuetify from 'vuetify';
import LegIcon from './LegIcon.vue'
import moment from 'moment';


export default {
  components: {
      LegIcon,
  },
  props: ['leg'],
  data() {
    return {
      test: ""
    }
  },
  computed: {
    icon: function() {
      switch(this.leg.mode) {
        case "foot":
          return "mdi-walk";
        case "bus":
          return "mdi-bus";
        case "metro":
          return "mdi-subway";
        case "tram":
          return "mdi-tram";
        case "rail":
          return "mdi-train";
      }

      return "mdi-help";
    },

    line_color: function() {
      if (this.leg.line.presentation.textColour !== undefined) {
        return '#' + this.leg.line.presentation.textColour;
      }
      return '#000000';
    },

    line_background_color: function() {
      console.log(this.leg.line.presentation.colour);
      if (this.leg.line.presentation.colour !== undefined) {
        return '#' + this.leg.line.presentation.colour;
      }
      return '#ffffff';
    },

    border_color: function() {
      if (this.leg.line.presentation.colour !== undefined) {
        return '#' + this.leg.line.presentation.colour;
      }
      return '#000000';
    },

    duration: function() {
      return Math.round(this.leg.duration / 60);
    },

    lineStyle: function() {
      console.log(this.leg.duration);
      return {
        line: true,
        walk: !this.leg.ride,
        short: this.leg.duration < 900, 
        medium: this.leg.duration >= 900 && this.leg.duration < 2700,
        long: this.leg.duration >= 2700
      }
    }

  },
};

</script>
<style scoped>
.connection  {
  padding: 8px;
}
.short {
  height: 150px;
}

.medium {
  height: 250px;
}

.long {
  height: 350px;
}

.mode {
  width: 50px;
  text-align: right;
  padding-right: 10px;
}

.line {
  position: relative;
  border-left: #040506 2.5px solid;
  z-index: 10;
  left: 27px;
  top: 0px;
  padding: 0;
  margin-top: -60px;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: -23px;
}

.walk {
  border-left: #040506 2px dotted;
}

.short .line {
  height: 125px;
}

.medium .line {
  height: 200px;
}

.long .line {
  height: 275px;
}


div {
  vertical-align: top;
  display: inline-block;
}

.line_description {
  border: 0.5px solid black;
  border-radius: 5px;
  padding: 3px;
  margin-bottom: 4px;
  margin-right: 4px;
  font-size: 80%;
  white-space:nowrap;
}

.direction {
  width: 200px;
  font-size: 14px;
  margin-left: 40px;
}
</style>